module.exports = __webpack_public_path__ + "img/Card details.56bd0a5c.svg";